// jQuery
jQuery(function ($) {
  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $(".totop");

  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      300,
      "swing"
    );
    return false;
  });

  $(".hamburguer, .spmenu-background").click(function () {
    $(".hamburguer").toggleClass("hamburguer_opened");
    $(".spmenu").toggleClass("spmenu_activated");
    $(".spmenu-background").toggleClass("spmenu-background_activated");
  });

  $(".ranking-period-item").click(function () {
    if (!$(this).hasClass("ranking-period-item_selected")) {
      $(".ranking-period-item").removeClass("ranking-period-item_selected");
      $(this).addClass("ranking-period-item_selected");

      var element = $(this);

      gsap.to(".ranking-list", {
        duration: 0.25,
        opacity: 0,
        onComplete: function () {
          $(".ranking-list").hide();
          $("#" + $(element).data("link")).show();

          gsap.fromTo(
            "#" + $(element).data("link"),
            { opacity: 0 },
            {
              duration: 0.25,
              opacity: 1,
            }
          );
        },
      });
    }
  });

  $.validator.messages.required = "必須項目です。";
  $.validator.messages.email = "有効なメールアドレスを入力してください。";
  $.validator.messages.equalTo = "メールアドレスが一致しません。";
  $.validator.setDefaults({
    errorClass: "form-invalid",
    errorElement: "span",
    errorPlacement: function (error, element) {
      if (
        !$(element).is(":checkbox") &&
        !($(element).attr("type") === "password")
      ) {
        error.insertAfter(element);
        element.next(".error-image").show();
      } else {
        error.insertAfter($(element).parent());
        $(element).parent().next(".error-image").show();
      }
    },
    success: function (label, element) {
      $(element).next(".error-image").hide();
    },
    ignore: ".ignore, :hidden",
  });

  var freeRegister = [
    "company",
    "affiliation",
    "position",
    "name",
    "phone",
    "announcement",
  ];

  var paidRegister = [
    "company",
    "affiliation",
    "position",
    "name",
    "phone",
    "zip",
    "prefecture",
    "city",
    "town",
    "build",
    "announcement",
  ];

  var businessRegister = [
    "affiliation",
    "position",
    "name",
    "phone",
    "announcement",
  ];

  var employeeRegister = [
    "branch",
    "affiliation",
    "position",
    "name",
    "phone",
    "announcement",
  ];

  $("#temp-free, #temp-paid").validate({
    rules: {
      user_login: {
        remote: {
          url: my_ajax_object.ajax_url,
          type: "post",
          data: {
            action: "check_email_exist",
            email: function () {
              return $("#user_login").val();
            },
          },
        },
      },
      user_login2: {
        equalTo: "#user_login",
      },
    },
    messages: {
      user_login: {
        remote: "このメールアドレスはすでに使用されています",
      },
    },
    submitHandler: function (form, e) {
      e.preventDefault();

      var formData = new FormData();

      formData.append("action", "register_user");
      formData.append("user_email", $("#user_login").val());

      if ($(form).is("#temp-paid")) {
        formData.append("type", "paid");
      } else {
        formData.append("type", "free");
      }

      $.ajax({
        url: my_ajax_object.ajax_url,
        type: "POST",
        cache: false,
        contentType: false,
        processData: false,
        data: formData,
        success: function (data) {
          $(".form-form").hide();
          $(".register-completed").show();
        },
      });
    },
  });

  $("#official-free, #official-paid, #official-association").validate({
    submitHandler: function (form, e) {
      e.preventDefault();

      if ($(form).is("#official-paid")) {
        fields = paidRegister;

        $(".form-verification.notification").html("");
        $('input[name="notification[]"]:checked').each(function (
          index,
          element
        ) {
          $(".form-verification.notification").append(
            "<span>" + $(element).val() + "</span>"
          );
        });
      } else if ($(form).is("#official-association")) {
        if ($("input[name='type']").val() == "business") {
          fields = businessRegister;
        } else {
          fields = employeeRegister;
        }

        $(".form-verification.notification").html("");
        $('input[name="notification[]"]:checked').each(function (
          index,
          element
        ) {
          $(".form-verification.notification").append(
            "<span>" + $(element).val() + "</span>"
          );
        });
      } else {
        fields = freeRegister;
      }

      fields.forEach(function (element, index) {
        $(".form-verification." + element).html($("#" + element).val());
      });

      $(".form-verification.findout").html("");
      $('input[name="findout[]"]:checked').each(function (index, element) {
        $(".form-verification.findout").append(
          "<span>" + $(element).val() + "</span>"
        );
      });

      $(".form-verification.interest").html("");
      $('input[name="interest[]"]:checked').each(function (index, element) {
        $(".form-verification.interest").append(
          "<span>" + $(element).val() + "</span>"
        );
      });

      $(form).hide();
      $("#official-verification").show();

      window.scrollTo(0, 0);
    },
  });

  $.validator.addMethod(
    "inCompanyArray",
    function (value, element, param) {
      return param.indexOf(value) !== -1;
    },
    "入力された値は存在しません。"
  );

  if (typeof autoCompleteCompanies === "undefined") {
    autoCompleteCompanies = [];
  }

  $("#temp-association").validate({
    rules: {
      user_login: {
        remote: {
          url: my_ajax_object.ajax_url,
          type: "post",
          data: {
            action: "match_email_domain",
            email: function () {
              return $("#user_login").val();
            },
            domain: function () {
              return $("#company").val();
            },
          },
        },
      },
      company: {
        inCompanyArray: autoCompleteCompanies,
      },
    },
    messages: {
      user_login: {
        remote: "すでに登録されている＠以降のドメインと一致しません。",
      },
    },
    submitHandler: function (form, e) {
      e.preventDefault();

      var formData = new FormData();

      formData.append("action", "register_user");
      formData.append("user_email", $("#user_login").val());
      formData.append("type", $("input[name='type']").val());
      formData.append("company", $("#company").val());

      if ($("input[name='type']").val() == "business") {
        formData.append("branch", $("#business").val());
      }

      $.ajax({
        url: my_ajax_object.ajax_url,
        type: "POST",
        cache: false,
        contentType: false,
        processData: false,
        data: formData,
        success: function (data) {
          $(".form-form").hide();
          $(".register-completed").show();
        },
        error: function (data) {
          $(
            '<span id="user_login-error" class="form-invalid">' +
              data.responseJSON.msg +
              "</span>"
          ).insertAfter($("#user_login").parent());
          $("#user_login").parent().next(".error-image").show();
        },
      });

      window.scrollTo(0, 0);
    },
  });

  $("#edit-profile").validate({
    rules: {
      password2: {
        equalTo: "#password",
      },
    },
    messages: {
      password2: {
        equalTo: "パスワードが一致しません。",
      },
    },
    submitHandler: function (form, e) {
      e.preventDefault();

      var formData = new FormData();

      formData.append("action", "update_profile");

      formData.append("affiliation", $("#affiliation").val());
      formData.append("position", $("#position").val());
      formData.append("name", $("#name").val());
      formData.append("phone", $("#phone").val());
      formData.append("password", $("#password").val());

      formData.append("company", $("#company").val());
      formData.append("branch", $("#branch").val());

      notification = "";
      $('input[name="notification[]"]:checked').each(function (index, element) {
        notification += (notification != "" ? "," : "") + $(element).val();
      });

      formData.append("notification", notification);

      $.ajax({
        url: my_ajax_object.ajax_url,
        type: "POST",
        cache: false,
        contentType: false,
        processData: false,
        data: formData,
        success: function (data) {
          $(".profile-container").hide();
          $(".profile-completed").show();
        },
      });

      window.scrollTo(0, 0);
    },
  });

  $(".paid-register, .free-register, .association-register").click(function () {
    var formData = new FormData();
    formData.append("action", "register_official_user");
    formData.append("uuid", $("#uuid").val());

    if ($(this).hasClass("paid-register")) {
      fields = paidRegister;
      notification = "";
      $('input[name="notification[]"]:checked').each(function (index, element) {
        notification += (notification != "" ? "," : "") + $(element).val();
      });

      formData.append("notification", notification);
      formData.append("type", "paid");
    } else if ($(this).hasClass("association-register")) {
      if ($("input[name='type']").val() == "business") {
        fields = businessRegister;
      } else {
        fields = employeeRegister;
      }

      notification = "";
      $('input[name="notification[]"]:checked').each(function (index, element) {
        notification += (notification != "" ? "," : "") + $(element).val();
      });

      formData.append("notification", notification);
      formData.append("type", $("input[name='type']").val());
    } else {
      fields = freeRegister;
      formData.append("type", "free");
    }

    fields.forEach(function (element, index) {
      formData.append(element, $("#" + element).val());
    });

    var findout = "";
    var interest = "";

    $('input[name="findout[]"]:checked').each(function (index, element) {
      findout += (findout != "" ? "," : "") + $(element).val();
    });
    $('input[name="interest[]"]:checked').each(function (index, element) {
      interest += (interest != "" ? "," : "") + $(element).val();
    });

    formData.append("findout", findout);
    formData.append("interest", interest);

    $.ajax({
      url: my_ajax_object.ajax_url,
      type: "POST",
      cache: false,
      contentType: false,
      processData: false,
      data: formData,
      success: function (data) {
        // console.log(data);
        $(".form-form").hide();
        $(".register-completed").show();
      },
    });
  });

  $(".backToForm").click(function () {
    $(this).closest(".form-form").hide();
    $("form.form-form").show();
    window.scrollTo(0, 0);
  });

  $(".login-tab").click(function () {
    $(".login-tab").removeClass("tab-headerItem_selected");
    $(this).addClass("tab-headerItem_selected");

    if ($(this).data("tab") == "login") {
      $("#login-register").hide();
      $("#login").show();
    } else {
      $("#login").hide();
      $("#login-register").show();
    }
  });

  $(".association-tab").click(function () {
    $(".association-tab").removeClass("tab-headerItem_selected");
    $(this).addClass("tab-headerItem_selected");

    $("#company").val("");
    $("#temp-association").validate().destroy();

    if ($(this).data("tab") == "employee") {
      $("input[name='type']").val("employee");
      $(".business-field").hide();
      $(".business-field").find(".form-input").addClass("ignore");
      $("#business").html("");
      $("#business").append("<option value=''>社名を入力してください</option>");
      $("#user_login").val("");
      $(".company-autocomplete").autocomplete("destroy").autocomplete({
        source: autoCompleteCompanies,
      });

      $("#temp-association").validate({
        rules: {
          user_login: {
            remote: {
              url: my_ajax_object.ajax_url,
              type: "post",
              data: {
                action: "match_email_domain",
                email: function () {
                  return $("#user_login").val();
                },
                domain: function () {
                  return $("#company").val();
                },
              },
            },
          },
          company: {
            inCompanyArray: autoCompleteCompanies,
          },
        },
        messages: {
          user_login: {
            remote: "すでに登録されている＠以降のドメインと一致しません。",
          },
        },
        submitHandler: function (form, e) {
          e.preventDefault();

          var formData = new FormData();

          formData.append("action", "register_user");
          formData.append("user_email", $("#user_login").val());
          formData.append("type", $("input[name='type']").val());
          formData.append("company", $("#company").val());

          if ($("input[name='type']").val() == "business") {
            formData.append("branch", $("#business").val());
          }

          $.ajax({
            url: my_ajax_object.ajax_url,
            type: "POST",
            cache: false,
            contentType: false,
            processData: false,
            data: formData,
            success: function (data) {
              $(".form-form").hide();
              $(".register-completed").show();
            },
          });

          window.scrollTo(0, 0);
        },
      });
    } else {
      $("input[name='type']").val("business");
      $(".business-field").find(".form-input").removeClass("ignore");
      $(".business-field").show();
      $("#business").html("");
      $("#business").append("<option value=''>社名を入力してください</option>");
      $("#user_login").val("");

      $(".company-autocomplete").autocomplete("destroy").autocomplete({
        source: autoCompleteCompaniesBusiness,
      });

      $("#temp-association").validate({
        rules: {
          user_login: {
            remote: {
              url: my_ajax_object.ajax_url,
              type: "post",
              data: {
                action: "match_email_domain",
                email: function () {
                  return $("#user_login").val();
                },
                domain: function () {
                  return $("#company").val();
                },
              },
            },
          },
          company: {
            inCompanyArray: autoCompleteCompaniesBusiness,
          },
        },
        messages: {
          user_login: {
            remote: "すでに登録されている＠以降のドメインと一致しません。",
          },
        },
        submitHandler: function (form, e) {
          e.preventDefault();

          var formData = new FormData();

          formData.append("action", "register_user");
          formData.append("user_email", $("#user_login").val());
          formData.append("type", $("input[name='type']").val());
          formData.append("company", $("#company").val());

          if ($("input[name='type']").val() == "business") {
            formData.append("branch", $("#business").val());
          }

          $.ajax({
            url: my_ajax_object.ajax_url,
            type: "POST",
            cache: false,
            contentType: false,
            processData: false,
            data: formData,
            success: function (data) {
              $(".form-form").hide();
              $(".register-completed").show();
            },
          });

          window.scrollTo(0, 0);
        },
      });
    }
  });

  $(".company-autocomplete").change(function () {
    if ($(this).val()) {
      var formData = new FormData();

      formData.append("action", "branch_by_name");
      formData.append("name", $(this).val());

      $.ajax({
        url: my_ajax_object.ajax_url,
        type: "POST",
        cache: false,
        contentType: false,
        processData: false,
        dataType: "json",
        data: formData,
        success: function (data) {
          console.log(data);
          if (!data.error) {
            $("#business").html("");
            data.list.forEach(function (element) {
              $("#business").append(
                "<option value='" + element + "'>" + element + "</option>"
              );
            });
          } else {
            $("#business").html("");
            $("#business").append(
              "<option value=''>社名を入力してください</option>"
            );
          }
        },
      });
    }
  });

  $(".company-autocomplete").autocomplete({
    source: autoCompleteCompanies,
  });

  $(".form-toggle").click(function () {
    if ($(this).hasClass("form-toggle_visible")) {
      $(this).prev().attr("type", "password");
      $(this).removeClass("form-toggle_visible");
    } else {
      $(this).prev().attr("type", "text");
      $(this).addClass("form-toggle_visible");
    }
  });

  var clickTime = 0;

  $(".bookmark-thumb").click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (Date.now() - clickTime < 1000) {
      return;
    } else {
      clickTime = Date.now();
    }

    var element = $(this);

    if ($(this).hasClass("bookmark-thumb_selected")) {
      var formData = new FormData();

      formData.append("action", "remove_bookmark");
      formData.append("id", $(this).data("id"));
      var action = "remove";
    } else {
      var formData = new FormData();

      formData.append("action", "add_bookmark");
      formData.append("id", $(this).data("id"));
      var action = "add";
    }

    $.ajax({
      url: my_ajax_object.ajax_url,
      type: "POST",
      cache: false,
      contentType: false,
      processData: false,
      dataType: "json",
      data: formData,
      success: function (data) {
        if (!data.error) {
          if (action == "add") {
            element.addClass("bookmark-thumb_selected");
          } else {
            element.removeClass("bookmark-thumb_selected");
          }
        }
      },
    });
  });

  $(".faq-question").click(function () {
    $(this).toggleClass("faq-question_opened");
  });

  $("h5.wp-block-heading").each(function (index, element) {
    var value = $(element).html();
    $(element).html(
      `<span class="h5-point">POINT</span><span class="h5-content">${value}</span>`
    );
  });

  $("#order").change(function () {
    const url = new URL(window.location.href);
    url.searchParams.set("order", $(this).val());
    window.location.href = url.toString();
  });

  $("#filter-year").change(function () {
    const url = new URL(window.location.href);

    url.searchParams.set("date", $(this).val());
    if (url.searchParams.has("npaged")) {
      url.searchParams.set("npaged", 1);
    }
    window.location.href = url.toString();
  });

  $(".backnumberCardWoPermission").click(function () {
    var html = $(this).html();

    $("#backnumberModal").find("#backnumberCardModal").html(html);

    $("#backnumberModal").modal({
      fadeDuration: 100,
    });
  });

  var processing = false;
  $(".viewmore").click(function () {
    if (!processing) {
      processing = true;

      var type = $("#hdtype").val();
      var page = parseInt($("#hdpage").val()) + 1;
      var qty = parseInt($("#hdqty").val());
      var max = parseInt($("#hdmax").val());
      var slug = $("#hdslug").val() != "" ? $("#hdslug").val() : "";
      var order = $("#hdorder").val() != "" ? $("#hdorder").val() : "";

      if (page <= max) {
        var formData = new FormData();

        formData.append("action", "view_more");
        formData.append("type", type);
        formData.append("page", page);
        formData.append("qty", qty);
        formData.append("slug", slug);
        formData.append("order", order);

        $.ajax({
          url: my_ajax_object.ajax_url,
          type: "POST",
          cache: false,
          contentType: false,
          processData: false,
          data: formData,
          success: function (data) {
            $("#ajaxContainer").append(data);
            $("#hdpage").val(page);

            if (page == max) {
              $(".viewmore").remove();
            }
            processing = false;
          },
        });
      }
    }
  });
});

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault(); // Previne o comportamento padrão
    const targetId = this.getAttribute("href");
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const yOffset = -120; // Ajusta o deslocamento aqui
      const y =
        targetElement.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;
      console.log(
        targetElement.getBoundingClientRect().top,
        window.pageYOffset,
        yOffset,
        y
      );
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  });
});

window.addEventListener("load", (event) => {
  const anchor = window.location.hash;
  if (anchor) {
    const element = document.querySelector(anchor);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: offsetTop - 120,
        behavior: "smooth",
      });
    }
  } else {
    const urlParams = new URLSearchParams(window.location.search);
    const isYellowPage = window.location.pathname.includes("partner");
    const hasCParam = urlParams.has("c");

    if (isYellowPage && hasCParam) {
      const element = document.getElementById("section-category");
      if (element) {
        const offsetTop = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: offsetTop - 120,
          behavior: "smooth",
        });
      }
    }
  }
});

// JavaScript

function printPage() {
  window.print();
}
